export default class UserAgentUtils {
  static isMobileDeviceWidth() {
    return matchMedia("(max-width: 1023px)").matches
  }
}
